<template>
  <div class="homepage">
    <m-title :titlelist="listitem"></m-title>
    <!-- 数据统计 -->
    <div class="homepage_content">
      <!-- 司机平台 -->
      <div class="carinfo">
        <div
          class="fleetnum"
          @click="gonavroute('motorcade')"
          style="cursor: pointer"
        >
          <div class="drivernum-box">
            <div class="item-name">车队数</div>
            <div class="item-num">{{ carnumber.fleetCount || 0 }}</div>
          </div>
          <img
            class="imgIcon"
            src="../../assets/homeImg/icon_figer.png"
            alt=""
          />
        </div>
        <div
          class="drivernum"
          @click="gonavroute('energycar', 1)"
          style="cursor: pointer"
        >
          <div class="drivernum-box">
            <div class="item-name">新能源电车</div>
            <div class="item-num">{{ carnumber.energyCarCount || 0 }}</div>
          </div>
          <img
            class="imgIcon"
            src="../../assets/homeImg/icon_figer.png"
            alt=""
          />
        </div>
        <div
          class="drivernum"
          @click="gonavroute('energycar', 2)"
          style="cursor: pointer"
        >
          <div class="drivernum-box">
            <div class="item-name">新能源氢车</div>
            <div class="item-num">{{ carnumber.hydrogenCarCount || 0 }}</div>
          </div>
          <img
            class="imgIcon"
            src="../../assets/homeImg/icon_figer.png"
            alt=""
          />
        </div>
        <div
          class="addele"
          @click="gonavroute('addstorestatelist')"
          style="cursor: pointer"
        >
          <div class="drivernum-box">
            <div class="item-name">充电桩</div>
            <!-- <div class="item-num">{{ carnumber.storeCount || 0 }}</div>  -->
            <div class="item-num">{{ carnumber.chargingPileCount || 0 }}</div>
          </div>
          <img
            class="imgIcon"
            src="../../assets/homeImg/icon_figer.png"
            alt=""
          />
        </div>
        <div class="createle">
          <div class="drivernum-box">
            <div class="item-name">换电站</div>
            <div class="item-num">{{ carnumber.changeStoreCount || 0 }}</div>
          </div>
        </div>
        <div class="addH">
          <div class="drivernum-box">
            <div class="item-name">加氢站</div>
            <div class="item-num">
              {{ carnumber.hydrogenStationCount || 0 }}
            </div>
          </div>
        </div>
      </div>
      <!-- 货场计划，运输量 -->
      <div class="formsearch">
        <div class="form-title">
          <div class="title-left">
            <div>
              <span class="text">计划来源</span>
              <el-select
                v-model="stname"
                placeholder="请选择"
                @input="changdiselect"
                class="inp"
              >
                <el-option
                  v-for="it in changdisel"
                  :key="it.value"
                  :value="it.value"
                  :label="it.label"
                ></el-option>
              </el-select>
            </div>
            <div>
              <span class="text">货物</span>
              <el-input
                type="text"
                placeholder="请输入"
                v-model="goodsname"
                class="inp"
              />
            </div>
            <div>
              <span class="text">船名</span>
              <el-input
                type="text"
                placeholder="请输入"
                v-model="shipname"
                class="inp"
              />
            </div>
            <div
              v-for="item in ywtype"
              :key="item.type"
              :class="[ywindex == item.type ? 'active' : 'ywstyle']"
              @click="checkywindex(item.type)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="title-right">
            <button class="chaxun">查询</button>
            <button class="reset">重置</button>
          </div>
        </div>
        <div class="bottominfo">
          <div class="bottom-left">
            <div class="left-title">
              <div class="name-text">
                车队排名
                <img
                  class="imgIcon"
                  src="../../assets/homeImg/icon_fingerd.png"
                  alt=""
                />
              </div>
              <div class="name-right">
                <div
                  v-for="item in hctype"
                  :key="item.type"
                  :class="[counttype == item.type ? 'active' : 'hcstyle']"
                  @click="checkhcindex(item.type)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="cdecharts" ref="cdecharts"></div>
          </div>
        </div>
      </div>
      <div class="formsearch" style="height: auto">
        <div class="bottominfo">
          <div class="bottom-left">
            <div class="left-title">
              <div class="name-text">
                当前作业中车辆状态
                <img
                  class="imgIcon"
                  src="../../assets/homeImg/icon_fingerd.png"
                  alt=""
                />
              </div>
            </div>
            <div>
              <div style="display: flex">
                <div
                  id="pieChart"
                  style="width: 350px; height: 300px"
                  ref="pieChartRef"
                ></div>
                <div class="card-list">
                  <div style="display: flex">
                    <div class="card1" @click="goPage">
                      <div class="card-desc">
                        <div class="num-row">
                          <span class="card-numb">{{ zyTotalCar }}</span
                          >辆
                        </div>
                        <div class="card-text">作业中车辆</div>
                      </div>
                    </div>
                    <div class="card2" @click="goPage">
                      <div class="card-desc">
                        <div class="num-row">
                          <span class="card-numb">{{ zyStartCar }}</span
                          >辆
                        </div>
                        <div class="card-text">作业中启动车辆</div>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex">
                    <div class="card3" @click="goPage">
                      <div class="card-desc">
                        <div class="num-row">
                          <span class="card-numb">{{ zyEnergyCar }}</span
                          >辆
                        </div>
                        <div class="card-text">作业中补能车辆</div>
                      </div>
                    </div>
                    <div class="card4" @click="goPage">
                      <div class="card-desc">
                        <div class="num-row">
                          <span class="card-numb">{{ zyStopCar }}</span
                          >辆
                        </div>
                        <div class="card-text">作业中熄火车辆</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-container"></div>
              </div>
            </div>
          </div>
        </div>
        <el-table
          :data="eachFleetTable"
          @row-click="goPage"
          :row-style="{ cursor: 'pointer' }"
        >
          <el-table-column
            prop="shortname"
            label="车队名"
            show-overflow-tooltip
          />
          <el-table-column
            prop="gongzhuozhong"
            label="作业中车辆"
            show-overflow-tooltip
          />
          <el-table-column
            prop="qidong"
            label="启动车辆"
            show-overflow-tooltip
          />
          <el-table-column prop="qita" label="补能车辆" show-overflow-tooltip />
          <el-table-column
            prop="xihuo"
            label="熄火车辆"
            show-overflow-tooltip
          />
        </el-table>
      </div>
      <div class="formsearch" style="height: auto">
        <div class="bottominfo">
          <div class="bottom-left">
            <div class="left-title">
              <div class="name-text">
                各货场数据对比
                <img
                  class="imgIcon"
                  src="../../assets/homeImg/icon_fingerd.png"
                  alt=""
                />
              </div>
              <div class="search-form">
                <span class="text">时间</span>
                <el-date-picker
                  v-model="stStartTime"
                  type="date"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
                <span class="text">至</span>
                <el-date-picker
                  v-model="stEndTime"
                  type="date"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
                <button class="chaxun" @click="getEachStnameProp">查询</button>
              </div>
            </div>
            <div class="row-container">
              <div class="color-row" v-for="row in stArray">
                <div class="row-name">
                  <div>{{ row.storename }}</div>
                </div>
              </div>
              <div class="card-container">
                <div class="op-card" v-for="col in stProps">
                  <div class="card-title">{{ col.label }}</div>
                  <div class="card-number" v-for="row in stArray">
                    <div
                      class="number-text"
                      @click="navigatorRoute(row.storename, col.prop)"
                    >
                      {{ row[col.prop] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import * as echarts from "echarts";
import dayjs from "dayjs";
export default {
  data() {
    return {
      listitem: [{ name: "首页" }],
      // 第一行
      carnumber: {}, //数据统计
      hctype: [
        {
          name: "按派车数",
          type: 2,
        },
        {
          name: "按实际派车兑现率",
          type: 4,
        },
        {
          name: "按预派车兑现率",
          type: 5,
        },
        {
          name: "按运输车次",
          type: 3,
        },
        {
          name: "按运输量",
          type: 1,
        },
      ],
      counttype: 2,
      carlist: [],
      energylist: [],
      gapStationlist: [],
      searchlist: [],
      ywtype: [
        { name: "近一周", type: 2 },
        { name: "近一月", type: 3 },
        { name: "近一年", type: 4 },
        { name: "昨日", type: 5 },
      ],
      changdisel: [
        { label: "前沿货场", value: "jiaotan" },
        { label: "港俊货场", value: "gangjun" },
        { label: "昊德", value: "haode" },
        { label: "琦晟", value: "qisheng" },
        { label: "睿鑫", value: "ruixin" },
        { label: "通达", value: "tongda" },
        { label: "富泉", value: "fuquan" },
      ],
      cdecharts: null,
      ywindex: 2,
      stname: "jiaotan",
      goodsname: "",
      shipname: "",
      //车队
      cdoption: {
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            return `
                <div style="font-size:12px;color:rgba(0,0,0,0.85);margin-bottom:10px;font-family:Source Han Sans CN-Medium;font-weight: 500;margin-bottom:23px">${params.name}</div>
                <div style="font-size: 12px;font-family: Source Han Sans CN-Normal;font-weight: 400;color: rgba(0,0,0,0.65);"><span style="font-size: 16px;font-family: Source Han Sans CN-Bold;font-weight: bold;color: #397EF0;;margin:2px">${params.value}</span></div>
              `;
          },
          extraCssText:
            "background-color:rgba(255, 255, 255, 0.8);padding:12px;box-shadow: 0px 3px 12px 1px rgba(57,126,240,0.22);border-radius: 4px;filter: blur(undefinedpx);border:none;",
        },
        grid: {
          left: "0",
          right: "50",
          bottom: "22", //下边距,
          top: "30",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          axisLabel: {
            //坐标轴字体颜色
            color: "rgba(0,0,0,0.85)",
            fontSize: "12",
            fontFamily: "Source Han Sans CN-Regular",
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格
            show: true,
            lineStyle: {
              color: "rgba(0, 0, 0, 0.1)",
              type: "dashed",
            },
          },
        },
        yAxis: {
          type: "category",
          inverse: true,
          axisLabel: {
            //坐标轴字体颜色
            color: "rgba(0, 0, 0, 0.85)",
            fontSize: "12",
            fontFamily: "Source Han Sans CN-Regular",
          },
          axisLine: {
            lineStyle: {
              color: "#CCCCCC",
            },
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格
            show: false,
          },
          data: [],
        },
        series: [
          {
            name: "",
            type: "bar",
            barWidth: "12px", //柱子宽度
            color: new echarts.graphic.LinearGradient(1, 1, 0, 0, [
              //渐变色
              {
                offset: 1,
                color: "#EE607E",
              },
              {
                offset: 0,
                color: "#FFA66A",
              },
            ]),
            itemStyle: {
              borderRadius: [2, 2, 0, 0],
            },
            data: [],
          },
          {
            name: "21",
            type: "bar",
            barWidth: 20,
            barGap: "-100%",
            data: [],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(1, 1, 0, 0, [
                //渐变色
                {
                  offset: 1,
                  color: "#EE607E",
                },
                {
                  offset: 0,
                  color: "#FFA66A",
                },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(1, 1, 0, 0, [
                  //渐变色
                  {
                    offset: 1,
                    color: "#EE607E",
                  },
                  {
                    offset: 0,
                    color: "#FFA66A",
                  },
                ]),
              },
            },
            label: {
              color: "#000",
              show: true,
              position: "right",
              distance: 4,
              fontSize: 14,
              formatter: "{c}",
            },
          },
        ],
      },
      limit: 15,
      page: 1,
      // todayStartTime: dayjs().format('YYYY-MM-DD 00:00:00'),
      // todayEndTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      startOfWeek: "",
      startOfMonth: "",
      startOfYear: "",
      yesterdayStart: dayjs().subtract(1, "day").format("YYYY-MM-DD 00:00:00"),
      yesterdayEnd: dayjs().subtract(1, "day").format("YYYY-MM-DD 23:59:59"),
      obj: {
        startTime: "",
        endTime: "",
        type: 2,
      },
      pieData: {},
      piecharts: null,
      pieOptions: {
        title: {
          text: "{a|100}辆\n作业中车辆",
          left: 60,
          top: "center",
          textStyle: {
            rich: {
              a: {
                align: "center",
                fontSize: 33,
                lineHeight: 40,
              },
            },
          },
        },
        legend: {
          icon: "circle",
          orient: "vertical",
          top: "center",
          right: 20,
          itemGap: 40,
          itemWidth: 16,
          itemHeight: 16,
          tooltip: {
            trigger: "item",
          },
        },
        series: [
          {
            center: [110, "center"],
            type: "pie",
            data: [
              {
                value: 335,
                name: "A",
              },
              {
                value: 234,
                name: "B",
              },
              {
                value: 1548,
                name: "C",
              },
            ],
            label: {
              show: false,
              //formatter: "{b}: {d}",
            },
            labelLine: {
              show: false,
            },
            radius: ["50%", "70%"],
          },
        ],
      },
      eachFleetTable: [],
      zyTotalCar: 0,
      zyStartCar: 0,
      zyStopCar: 0,
      zyEnergyCar: 0,
      stStartTime: "",
      stEndTime: "",
      stArray: [],
      stProps: [
        { label: "计划数", prop: "planCount" },
        { label: "进行中计划", prop: "planingCount" },
        { label: "已完成计划", prop: "planedCount" },
        { label: "运输车队", prop: "fleetCount" },
        { label: "派车数", prop: "dispathCount" },
        { label: "运输车次", prop: "carWorkedCount" },
        { label: "运输吨数", prop: "carWorkedDun" },
      ],
    };
  },
  components: {
    mTitle,
  },
  created() {
    const today = new Date().getTime();
    let week = today - 6 * 24 * 3600 * 1000;
    let month = today - 29 * 24 * 3600 * 1000;
    let year = today - 364 * 24 * 3600 * 1000;
    this.startOfWeek = dayjs(week).format("YYYY-MM-DD 00:00:00");
    this.startOfMonth = dayjs(month).format("YYYY-MM-DD 00:00:00");
    this.startOfYear = dayjs(year).format("YYYY-MM-DD 00:00:00");
    this.obj.startTime = dayjs(week).format("YYYY-MM-DD 00:00:00");
    this.obj.endTime = dayjs(today).format("YYYY-MM-DD HH:mm:ss");
  },
  mounted() {
    this.$nextTick((_) => {
      this.cdecharts = echarts.init(this.$refs.cdecharts);
      // console.log(this.cdecharts);
      this.cdecharts.getZr().off("click");
      this.cdecharts.getZr().on("click", (params) => {
        let pointInPixel = [params.offsetX, params.offsetY];

        if (this.cdecharts.containPixel("grid", pointInPixel)) {
          let pointInGrid = this.cdecharts.convertFromPixel(
            {
              seriesIndex: 0,
            },
            pointInPixel
          );
          let xIndex = pointInGrid[1]; // 索引
          let handleIndex = Number(xIndex);
          // let seriesObj = this.cdecharts.getOption(); 	// 图表object对象
          let op = this.cdecharts.getOption();
          //获得图表中点击的列
          let dataY = op.yAxis[0].data[handleIndex]; //获取点击的列名
          // let dataX = seriesObj.series[0].data[handleIndex]
          // console.log(dataY, dataX);
          this.obj.goodsname = this.goodsname;
          this.obj.shipname = this.shipname;
          this.obj.stname = this.stname;
          this.obj.fleetname = dataY;
          if (this.counttype == 1 || this.counttype == 3) {
            this.obj.plantype = 3;

            this.$router.push({
              name: "jobdetails",
              query: { obj: JSON.stringify(this.obj) },
            });
          } else {
            this.$router.push({
              name: "paichejilu",
              query: { obj: JSON.stringify(this.obj) },
            });
          }
        }
      });
      this.piecharts = echarts.init(this.$refs.pieChartRef);
      this.piecharts.setOption(this.pieOptions);
    });
    this.getnumber();
    this.getcarlistzhu();
    this.getCarWorkStatusStatistics();
    this.getEachFleetHomeCarStatistics();
    this.getEachStnameProp();
    window.addEventListener("resize", () => {
      this.cdecharts.resize();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.cdecharts.resize();
    });
  },
  methods: {
    gonavroute(name, num) {
      switch (name) {
        case "motorcade":
          let obj = { corptype: 1 };
          this.$router.push({
            name: "motorcade", 
            query: { obj: JSON.stringify(obj) },
          }); 
          break;

        case "energycar":
          if (num == 1) {
            this.$router.push({ name: "energycar" });
          } else {
            this.$router.push({ name: "energycarH" });
          }
          break;
        case "addstorestatelist":
          this.$router.push({ name: "addstorestatelist" });
          break;
      }
    },
    // gocarlist(){
    //     this.$router.push({ name: 'energycar'})
    // },
    navigatorRoute(row, prop) {
      let obj = {};
      obj.stname =
        row === "港俊货场" ? "gangjun" : row === "前沿货场" ? "jiaotan" : "";
      obj.startTime = this.stStartTime;
      obj.endTime = this.stEndTime;
      obj.plantype = 3;
      let name;
      switch (prop) {
        case "planCount":
          name = "planlist";
          obj.status = null;
          obj.selectVal = "全部";

          break;
        case "planingCount":
          name = "planlist";
          obj.status = 0;
          obj.selectVal = "进行中";
          break;
        case "planedCount":
          name = "planlist";
          obj.status = 1;
          obj.selectVal = "完成";
          break;
        case "fleetCount":
          name = "zuoyechaxun";
          break;
        case "dispathCount":
          name = "zuoyechaxun";
          break;
        case "carWorkedCount":
          name = "zuoyechaxun";
          break;
        case "carWorkedDun":
          name = "zuoyechaxun";
          break;
      }
      this.$router.push({ name, query: { obj: JSON.stringify(obj) } });
    },
    changdiselect(e) {
      this.stname = e;
      this.getcarlistzhu();
      this.obj.stname = e;
    },
    //切换周期
    checkywindex(index) {
      this.ywindex = index;
      this.getcarlistzhu();
      this.obj.type = index;
      switch (index) {
        case 2:
          this.obj.startTime = this.startOfWeek;
          break;
        case 3:
          this.obj.startTime = this.startOfMonth;
          break;
        case 4:
          this.obj.startTime = this.startOfYear;
          break;
        case 5:
          this.obj.startTime = this.yesterdayStart;
          this.obj.endTime = this.yesterdayEnd;
          break;
      }
    },
    // //切换货场
    checkhcindex(index) {
      this.counttype = index;
      this.getcarlistzhu();
    },
    //获取计划数等
    async getnumber() {
      const { data } = await this.$http(
        "api1",
        "home/statistics/numberstatistics",
        "get"
      );
      if (!data || data.code != "0") return;
      // console.log(data.data);
      this.carnumber = data.data;
    },
    getPercent(part, total) {
      if (total === 0) {
        return 0;
      } else {
        let percentage = parseInt((part / total).toFixed(4) * 100);
        return percentage + "%";
      }
    },
    //饼状图和卡片
    async getCarWorkStatusStatistics() {
      const { data } = await this.$http(
        "api1",
        "home/statistics/carWorkStatusStatistics",
        "get"
      );
      if (!data || data.code != "0") return;
      this.pieOptions.series[0].data = [];
      this.pieOptions;
      this.pieOptions.series[0].data.push({
        value: data.data[2].value,
        name:
          "补能" +
          "：" +
          this.getPercent(data.data[2].value, data.data[3].value),
        itemStyle: {
          color: "#1DC679",
        },
      });
      this.pieOptions.series[0].data.push({
        value: data.data[1].value,
        name:
          data.data[1].name +
          "：" +
          this.getPercent(data.data[1].value, data.data[3].value),
        itemStyle: {
          color: "#FFAC4C",
        },
      });
      this.pieOptions.series[0].data.push({
        value: data.data[0].value,
        name:
          data.data[0].name +
          "：" +
          this.getPercent(data.data[0].value, data.data[3].value),
        itemStyle: {
          color: "#2DA1EA",
        },
      });
      this.zyTotalCar = data.data[3].value;
      this.zyStartCar = data.data[0].value;
      this.zyStopCar = data.data[1].value;
      this.zyEnergyCar = data.data[2].value;
      this.pieOptions.title.text = `{a|${data.data[3].value}}辆\n作业中车辆`;
      this.$nextTick((_) => {
        this.piecharts.setOption(this.pieOptions);
      });
      // console.log(data.data);
      //this.carnumber = data.data;
    },
    //获取车队表格
    async getEachFleetHomeCarStatistics() {
      const { data } = await this.$http(
        "api1",
        "home/statistics/fleetCarWorkStatusStatistics",
        "get"
      );
      if (!data || data.code != "0") return;
      this.eachFleetTable = data.data;
    },
    async getEachStnameProp() {
      const { data } = await this.$http(
        "api1",
        "home/statistics/eachStnameProp",
        "get",
        {
          starttime: this.stStartTime,
          endtime: this.stEndTime,
        }
      );
      if (!data || data.code != "0") return;
      this.stArray = data.data;
      //this.eachFleetTable = data.data;
    },
    goPage() {
      this.$router.push({ name: "carDataStatistics" });
    },
    //车队运输统计
    async getcarlistzhu() {
      const { stname, goodsname, shipname, limit, page, counttype } = this;
      const { data } = await this.$http(
        "api1",
        "/home/statistics/homeFleetTransportCount",
        "get",
        {
          stname,
          goodsname,
          shipname,
          limit,
          page,
          counttype,
          type: this.ywindex,
        }
      );
      this.cdoption.yAxis.data = [];
      this.cdoption.series[0].data = [];
      this.cdoption.series[1].data = [];
      data.data.list.forEach((item) => {
        this.cdoption.yAxis.data.push(item.name);
        this.cdoption.series[0].data.push(item.value);
        this.cdoption.series[1].data.push(item.value);
      });
      this.cdoption.series[1].label.formatter =
        counttype == 1
          ? "{c}吨"
          : counttype == 2
          ? "{c}辆"
          : counttype == 3
          ? "{c}次"
          : `{c}%`;
      this.$nextTick((_) => {
        this.cdecharts.setOption(this.cdoption);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin box {
  .drivernum-box {
    padding-left: 30%;
    box-sizing: border-box;
    text-align: center;

    .item-name {
      margin-top: 20px;
      font-size: 100%;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
    }

    .item-num {
      margin-top: 15px;
      font-size: 180%;
      color: #fff;
      font-family: Source Han Sans CN;
      font-weight: bold;
    }
  }
}

@mixin between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@mixin title {
  height: 36px;
  background: url(../../assets/homeImg/pic_title.png) no-repeat center center;
  background-size: 100% 100%;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-style: italic;
  line-height: 36px;
  padding-left: 21px;
  box-sizing: border-box;
}

.homepage {
  position: relative;
  height: 100%;

  .homepage_content {
    height: calc(100% - 50px);
    width: 100%;
    background: #f5f6fa;
    padding: 10px;
    box-sizing: border-box;
    overflow: auto;

    .carinfo {
      @include between;
      width: 100%;
      height: 152px;
      margin-top: 10px;

      .drivernum {
        width: 16%;
        height: 100%;
        background: url(../../assets/homeImg/pic_dispatch.png) 100% 100%
          no-repeat;
        background-size: 100% 100%;
        padding: 10px;
        box-sizing: border-box;
        position: relative;
        @include box;
        .imgIcon {
          position: absolute;
          right: 15px;
          bottom: 30px;
          width: 20px;
          height: 30px;
        }
      }

      .fleetnum {
        width: 16%;
        height: 100%;
        background: url(../../assets/homeImg/pic_ptqys.png) 100% 100% no-repeat;
        background-size: 100% 100%;
        padding: 10px;
        box-sizing: border-box;
        position: relative;
        @include box;
        .imgIcon {
          position: absolute;
          right: 15px;
          bottom: 30px;
          width: 20px;
          height: 30px;
        }
      }

      .addele {
        width: 16%;
        height: 100%;
        background: url(../../assets/homeImg/pic_cdz.png) 100% 100% no-repeat;
        background-size: 100% 100%;
        padding: 10px;
        box-sizing: border-box;
        position: relative;
        @include box;
        .imgIcon {
          position: absolute;
          right: 15px;
          bottom: 30px;
          width: 20px;
          height: 30px;
        }
      }

      .createle {
        width: 16%;
        height: 100%;
        background: url(../../assets/homeImg/pic_hdz.png) 100% 100% no-repeat;
        background-size: 100% 100%;
        padding: 10px;
        box-sizing: border-box;
        @include box;
        // .imgIcon{
        //     position: absolute;
        //     right: 15px;
        //     bottom: 30px;
        //     width: 20px;
        //     height: 30px
        // }
      }

      .addH {
        width: 16%;
        height: 100%;
        background: url(../../assets/homeImg/pic_jqzd.png) 100% 100% no-repeat;
        background-size: 100% 100%;
        padding: 10px;
        box-sizing: border-box;
        @include box;
        // .imgIcon{
        //     position: absolute;
        //     right: 15px;
        //     bottom: 30px;
        //     width: 20px;
        //     height: 30px
        // }
      }
    }

    .formsearch {
      padding: 20px;
      height: 590px;
      background-color: #fff;
      border-radius: 10px;
      box-sizing: border-box;
      margin-top: 10px;

      .form-title {
        display: flex;
        justify-content: space-between;

        .title-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .text {
            font-size: 80%;
            margin: 0 10px;
          }

          .inp {
            width: 110px;
            height: 30px;
          }

          .ywstyle {
            width: 80px;
            height: 30px;
            border: 1px solid #17b6a1;
            border-radius: 4px;
            text-align: center;
            line-height: 30px;
            font-size: 16px;
            color: #17b6a1;
            margin-left: 15px;
            cursor: pointer;
          }

          .active {
            width: 80px;
            height: 30px;
            border: 1px solid #17b6a1;
            border-radius: 4px;
            text-align: center;
            line-height: 30px;
            font-size: 16px;
            color: #fff;
            background-color: #17b6a1;
            margin-left: 15px;
            cursor: pointer;
          }
        }

        .title-right {
          .chaxun {
            width: 80px;
            height: 30px;
            background: #17b6a1;
            border-radius: 8px;
            color: #fff;
            line-height: 30px;
            text-align: center;
            border: none;
            font-size: 80%;
          }

          .reset {
            width: 80px;
            height: 30px;
            background-color: #f5f6fa;
            border-radius: 8px;
            color: #17b6a1;
            line-height: 30px;
            text-align: center;
            border: none;
            font-size: 80%;
            margin-left: 15px;
          }
        }
      }

      .bottominfo {
        height: calc(100% - 50px);
        background-color: #fff;
        width: 100%;
        margin-top: 10px;

        .bottom-left {
          width: 100%;
          height: 100%;
          padding: 21px;
          box-sizing: border-box;

          .left-title {
            @include between;

            .name-text {
              @include title;
              .imgIcon {
                // position: absolute;
                // right: 15px;
                // bottom: 30px;
                vertical-align: middle;
                width: 25px;
                height: 30px;
              }
            }

            .name-right {
              display: flex;
              justify-content: flex-end;
              align-items: center;

              .hcstyle {
                // width: 84px;
                height: 42px;
                padding: 0 10px;
                border: 1px solid #17b6a1;
                border-radius: 4px;
                text-align: center;
                line-height: 42px;
                font-size: 16px;
                color: #17b6a1;
                margin-left: 15px;
                cursor: pointer;
              }

              .active {
                // width: 84px;
                padding: 0 10px;
                height: 42px;
                border: 1px solid #17b6a1;
                border-radius: 4px;
                text-align: center;
                line-height: 42px;
                font-size: 16px;
                color: #fff;
                background-color: #17b6a1;
                margin-left: 15px;
                cursor: pointer;
              }
            }
          }

          .cdecharts {
            width: 100%;
            height: 450px;
          }
        }
      }
    }
  }
}
.card-list {
  padding-top: 20px;
}
@mixin card {
  width: 14vw;
  height: 5.8vw;
  position: relative;
  margin-bottom: 16px;
  margin-right: 25px;
  cursor: pointer;
  .num-row {
    margin-bottom: 10px;
    text-align: center;
  }
  color: #333333;
  .card-desc {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
  }
  font-size: 0.7vw;
  .card-numb {
    font-size: 1.7vw;
  }
}
.card1 .card-numb,
.card4 .card-numb {
  color: #4f48c9;
}
.card2 .card-numb,
.card3 .card-numb {
  color: #319ab2;
}
@for $i from 1 through 4 {
  .card#{$i} {
    @include card;
    background-image: url(../../assets/homeImg/icon_0#{$i}.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
.bg-container {
  flex: 1;
  height: 300px;
  background-image: url(../../assets/homeImg/bj_pic.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.search-form {
  margin-left: 10%;
  margin-right: auto;
  .text {
    font-size: 80%;
    margin: 10px;
  }
  .chaxun {
    width: 80px;
    height: 30px;
    background: #17b6a1;
    border-radius: 8px;
    color: #fff;
    line-height: 30px;
    text-align: center;
    border: none;
    font-size: 80%;
    margin-left: 10px;
  }
}
.row-name {
  background-color: #fff;
  width: 100px;
  height: 100%;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-evenly;
  .op-card:first-child {
    margin-left: 100px;
  }
}
.color-row {
  width: 100%;
  height: 50px;
  background-color: #cbebff;
  margin: 20px 0 20px 0;
  padding: 6px;
  box-sizing: border-box;
  border-radius: 6px;
}
.op-card {
  background-color: rgba(255, 255, 255, 0.2); /* 半透明背景 */
  backdrop-filter: blur(10px); /* 背景模糊 */
  border-radius: 8px;
  width: 134px;
  height: calc(100% - 10px);
  box-sizing: border-box;
  box-shadow: 0 0 10px 0 rgba(51, 51, 51, 0.2);
  margin: 6px 0;
  .card-title {
    color: #076e60;
    margin-top: 5px;
    text-align: center;
  }

  .card-number {
    margin-top: 20px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    .number-text {
      text-align: center;
      min-width: 60px;
      padding: 0 6px;
      height: 30px;
      background-color: #fff;
      border-radius: 15px;
      line-height: 30px;
      cursor: pointer;
    }
  }
  .card-number:first-child {
    margin-top: 15px;
  }
}
.row-name {
  background-color: #fff;
  width: 100px;
  height: 100%;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-container {
  margin-top: 20px;
  position: relative;
  width: 100%;
  overflow: hidden;
  font-size: 16px;
  .color-row:first-child {
    margin-top: 50px;
  }
  .color-row:nth-child(odd) {
    background-color: #c0eee9;
  }
  .color-row:nth-child(even) {
    background-color: #cbebff;
  }
}
</style>
